import { render, staticRenderFns } from "./SignupResult.vue?vue&type=template&id=9c1c159c"
import script from "./SignupResult.vue?vue&type=script&lang=js"
export * from "./SignupResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports